import React, { FC } from 'react';
import { useField } from 'formik';
import { FormHelperText, TextField } from '@mui/material';
import { format } from 'date-fns';
import { DateTimePicker } from '@mui/x-date-pickers';

interface FormFieldDateTimeProps {
  label: string;
  name: string;
  readonly?: boolean;
  disableFuture?: boolean;
  disablePast?: boolean;
  autoFocus?: boolean;
  maxDate?: Date;
  minDate?: Date;
}

const FormFieldDateTime: FC<FormFieldDateTimeProps> = ({
  label,
  name,
  readonly,
  disableFuture,
  disablePast,
  autoFocus,
  maxDate,
  minDate,
}: FormFieldDateTimeProps) => {
  const [field, meta, helpers] = useField(name);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const isValidDate = (d: any) => {
    if (Object.prototype.toString.call(d) === '[object Date]') {
      // it is a date
      if (isNaN(d)) {
        // date object is not valid
        return false;
      } else {
        // date object is valid
        return true;
      }
    } else {
      // not a date object
      return false;
    }
  };

  return (
    <>
      <DateTimePicker
        label={label}
        disableFuture={disableFuture}
        disablePast={disablePast}
        value={field.value ?? null}
        onChange={(newValue: Date | null) => {
          if (newValue != null && isValidDate(newValue) && newValue.getFullYear() > 1900) {
            helpers.setValue(format(newValue, "yyyy-MM-dd'T'HH:mm"));
          }
          if (newValue == null) {
            helpers.setValue(newValue);
          }
        }}
        disabled={readonly}
        disableMaskedInput
        inputFormat="d.M.yyyy HH:mm"
        autoFocus={autoFocus}
        maxDate={maxDate}
        minDate={minDate}
        openTo={'day'}
        views={['year', 'month', 'day', 'hours', 'minutes']}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        renderInput={(props: any) => <TextField size="small" {...props} error={!!meta.error} />}
      />
      {meta.error && (
        <FormHelperText sx={{ pl: 2 }} error={!!meta.error}>
          {meta.error}
        </FormHelperText>
      )}
    </>
  );
};

FormFieldDateTime.displayName = 'FormFieldDateTime';

export default FormFieldDateTime;
